import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NextLink from "next/link";
import removeMarkdown from "remove-markdown";

import CloudinaryImage from "../Common/CloudinaryImage";

function getHeadline(item) {
  const headline = item.headline || item.excerpt || item.description;

  return removeMarkdown(headline);
}

export default function PostList({ posts }) {
  const theme = useTheme();

  return (
    <Grid container spacing={{ xs: 2, sm: 6 }}>
      {posts.map((item, i) => (
        <Grid item xs={12} key={i} data-aos={"fade-up"}>
          <Box
            component={Card}
            boxShadow={{ xs: 1, sm: 3 }}
            width={"100%"}
            height={"100%"}
            borderRadius={5}
            sx={{
              transition: "all .2s ease-in-out",
              "&:hover": {
                transform: `translateY(-${theme.spacing(1 / 2)})`,
              },
            }}
          >
            <NextLink href={item.link} passHref>
              <CardActionArea
                href={item.link}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                {item.coverImage && (
                  <CardMedia
                    title={item.title}
                    sx={{
                      minHeight: 225,
                      minWidth: { xs: "100%", sm: 300 },
                      position: "relative",
                    }}
                  >
                    <CloudinaryImage
                      src={item.coverImage}
                      alt={item.title}
                      layout="fill"
                      objectFit="cover"
                    />
                  </CardMedia>
                )}
                <Box
                  component={CardContent}
                  display="flex"
                  flexDirection="column"
                  height={"100%"}
                >
                  <Box
                    component={Typography}
                    variant={"h5"}
                    gutterBottom
                    fontWeight={500}
                    align={"left"}
                  >
                    {item.title}
                  </Box>
                  <Box
                    component={Typography}
                    variant={"body2"}
                    gutterBottom
                    align={"left"}
                  >
                    {getHeadline(item).substring(0, 200) + "..."}
                  </Box>
                  <Box flexGrow={1} />
                  {item.categories && (
                    <Grid container direction="row" spacing={2}>
                      {item.categories.map((category, i) => (
                        <Grid item key={i}>
                          <Chip label={category} size="small" />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
              </CardActionArea>
            </NextLink>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
